module.exports = __webpack_public_path__ + "img/new_biaoti.49d847cb.png";